import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white text-main flex cursor-pointer items-center gap-2 rounded-full py-2 pr-4 pl-2 transition-colors',
    color: 'size-5 rounded-full border-2 border-white',
    text: 'heading-s-bold transition-colors'
  },
  variants: {
    active: {
      true: {
        base: 'bg-blue-dark text-white'
      }
    }
  }
});
